export default "__VITE_ASSET__$0DK5st4__"